import { getApiUrl } from '../utils/apiUrl';

const API_BASE = getApiUrl();

export const fetchWidgetConfigs = async (token) => {
  const res = await fetch(`${API_BASE}/widget-configs`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunne ikke hente modul-oppsett');
  return res.json();
};

export const saveWidgetConfigs = async (token, configs) => {
  const res = await fetch(`${API_BASE}/widget-configs`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ configs }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke lagre modul-oppsett');
  }
  return res.json();
};

export const fetchWidgetCategories = async (token) => {
  const res = await fetch(`${API_BASE}/widget-configs/categories`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunne ikke hente kategorirekkefølge');
  return res.json();
};

export const saveWidgetCategories = async (token, categories) => {
  const res = await fetch(`${API_BASE}/widget-configs/categories`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ categories }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke lagre kategorirekkefølge');
  }
  return res.json();
};
